import React from 'react'
import ReportsContextProvider, { ReportsContext, ACTIONS } from './context/ReportsContextProvider';
import InterectionDetailsController from './interection-details-report/components/InterectionDetailsController'
import UnconfirmedSubscriptionController from './unconfirmed-subscription-report/components/UnconfirmedSubscriptionController'
import OficinaVirtualController from './oficina-virtual/components/OficinaVirtualController'

function TablesReportsController({props, qtdRowPage}) {
    const [nameTable, setNameTable] = React.useState("detalle-interacciones")
    const [state, dispatch] = React.useContext(ReportsContext);

  return (
    <div className="bg-white">
        <nav className="container-table pl-0 pr-0 pt-0">
            <ul className="nav nav-tabs nav-justified" id="myTab" role="tablist">
                <li className="nav-item">
                    <a className="nav-link active" id="interection-details" onClick={() => setNameTable("interection-details")} data-toggle="tab" href="#interaccionDetail" role="tab" aria-controls="interaccionDetail" aria-selected="true" data-lineheight="30" data-fontsize="18" >Detalle Interacciones</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" id="unconfirmed-subscription" onClick={() => setNameTable("unconfirmed-subscription")} data-toggle="tab" href="#unconfirmedSubscription" role="tab" aria-controls="unconfirmedSubscription" aria-selected="true" data-lineheight="30" data-fontsize="18" >{props.title_page_unconfirmed_subscription}</a>
                </li>
                <li className="nav-item">
                    <a className="nav-link" id="oficina-virtual" data-toggle="tab" href="#oficinaVirtual" onClick={() => setNameTable("oficina-virtual")} role="tab" aria-controls="oficinaVirtual" aria-selected="false" data-lineheight="30" data-fontsize="18">{props.title_page_oficina_virtual}</a>
                </li>
            </ul>
        </nav>
        <div className="tab-content" id="myTabContent">
            <div className="tab-pane fade show active" id="interaccionDetail" role="tabpanel" aria-labelledby="interection-details">
            <InterectionDetailsController props={{...props, nameTable, qtdRowPage, state, dispatch, ACTIONS}}/>
            </div>
            <div class="tab-pane fade" id="unconfirmedSubscription" role="tabpanel" aria-labelledby="unconfirmed-subscription">
                <UnconfirmedSubscriptionController props={{...props, nameTable, qtdRowPage}}/>
            </div>
            <div class="tab-pane fade" id="oficinaVirtual" role="tabpanel" aria-labelledby="oficina-virtual">
                <OficinaVirtualController props={{ ...props, qtdRowPage }}/>
            </div>
        </div>
    </div>
  )
}

const TablesReportsControllerWithProvider = ({props, qtdRowPage}) => (
    <ReportsContextProvider>
      <TablesReportsController props={props} qtdRowPage={qtdRowPage} />
    </ReportsContextProvider>
  );
export default TablesReportsControllerWithProvider;